import $ from 'jquery';

import siteHeader from './site-header';
import siteNavigation from './site-navigation';

document.addEventListener("DOMContentLoaded", () => {
  const bodyElement = $('body');
  const loadingClass  = 'loading';

  console.log('APP DOMContentLoaded');
  setTimeout(() => {
    bodyElement.removeClass(loadingClass);
  }, 250);

  // siteHeader();
  siteNavigation();
});
